import React from 'react';
import { useConsent } from '../context/ConsentContext';
import { acceptAll, acceptEssential } from '../utils/consent';

export default function CookieBanner() {
  const { showBanner, setShowBanner } = useConsent();

  if (!showBanner) return null;

  const handleAcceptAll = () => {
    acceptAll();
    setShowBanner(false);
    // DSGVO: PostHog erst JETZT initialisieren (nach Consent)
    if (window.posthog && !window.__posthog_initialized) {
      window.__posthog_initialized = true;
      window.posthog.init("phc_yJW1VjHGGwmCbbrtczfqqNxgBDbhlhOWcdzcIJEOTFE", {
        api_host: "https://us.i.posthog.com",
        person_profiles: "identified_only",
      });
    }
  };

  const handleEssential = () => {
    acceptEssential();
    setShowBanner(false);
  };

  const handleSettings = () => {
    window.dispatchEvent(new Event('openCookieSettings'));
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-black border-t border-white/10 p-6">
      <div className="max-w-4xl mx-auto">
        <div className="flex flex-col md:flex-row gap-6 items-start md:items-center">
          {/* Cookie Emoji mit Green Glow */}
          <div className="flex-shrink-0">
            <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-[#10B981] to-[#059669] flex items-center justify-center text-3xl glow-green-soft">
              🍪
            </div>
          </div>
          
          {/* Text Content */}
          <div className="flex-1 space-y-2">
            <p className="text-white font-bold text-lg">Wir respektieren deine Privatsphäre.</p>
            <p className="text-white/70 text-sm leading-relaxed">
              Einige Cookies sind notwendig, damit Snapshot korrekt funktioniert. 
              Andere helfen uns, Inhalte zu verbessern und technische Abläufe zu optimieren.
            </p>
            <p className="text-white/50 text-xs leading-relaxed">
              Du kannst selbst entscheiden, welche Cookies du zulässt. 
              Deine Auswahl kannst du jederzeit ändern.
            </p>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto md:min-w-fit">
            <button
              onClick={handleEssential}
              className="px-6 py-3 border-2 border-white/30 text-white rounded-xl hover:bg-white/5 hover:border-white/50 transition-all font-semibold text-sm whitespace-nowrap"
            >
              Nur Notwendige
            </button>
            <button
              onClick={handleSettings}
              className="px-6 py-3 border-2 border-white/30 text-white rounded-xl hover:bg-white/5 hover:border-white/50 transition-all font-semibold text-sm whitespace-nowrap"
            >
              Einstellungen
            </button>
            <button
              onClick={handleAcceptAll}
              className="px-6 py-3 bg-[#10B981] text-black rounded-xl hover:bg-[#059669] transition-all font-bold text-sm glow-green pulse-glow shine-effect whitespace-nowrap"
            >
              Alle akzeptieren
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}